import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseCardModule } from '@fuse/components/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RefListPipe } from './pipes/refList/ref-list.pipe';
import { StatusFormatPipe } from './pipes/statusFormat/status-format.pipe';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { FileFormatPipe } from './pipes/fileFormat/file-format.pipe';
import { FeaturesDirective } from './directives/features.directive';
import { CurrencyDecimalDirective } from './directives/currency-decimal-directive';
import { MobileStoreStnComponent } from '../modules/auth/mobile-store-btn/mobile-store-btn.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    TranslocoRootModule,
  ],
  declarations: [
    RefListPipe,
    StatusFormatPipe,
    SnackBarComponent,
    FileFormatPipe,
    FeaturesDirective,
    CurrencyDecimalDirective,
    MobileStoreStnComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RefListPipe,
    StatusFormatPipe,
    FuseCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SnackBarComponent,
    MatSnackBarModule,
    FileFormatPipe,
    FeaturesDirective,
    CurrencyDecimalDirective,
    MobileStoreStnComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
